
import React, { useState, useEffect, useRef } from "react";
import "./Alliteams.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FaCommentAlt, FaChevronDown, FaChevronUp, FaBars, FaTimes } from "react-icons/fa";

import 'semantic-ui-css/semantic.min.css';
import Profile from "./Profile";
import Payment from "./Payment";
import Order from "./Order";
import Favorites from "./Favorites";
import { Favorite } from "@mui/icons-material";
// import Address from "./Address";
import Support from "./Support";
import Settings from "./Settings";
import axios from 'axios';
import { FaUser, FaBiking, FaShoppingCart, FaCreditCard, FaList, FaHeart, FaMapMarkerAlt, FaBell, FaHeadset, FaCog, FaMoneyCheckAlt } from "react-icons/fa";
import Notifications from "./Notifications";
import { useLocation } from 'react-router-dom';
// import Payments from "./Payments";
import Orderpayments from "./Orderpayments";
import AddWalletEmployee from "./AddWalletEmpolyee";
import menu1 from "../Profile/pumpkin-1768857_1280.jpg";
import SidescrollAdvertisements from './SidescrollAdvertisements';
// import DeliveryPatnerdata from "./DeliveryPatnerdata";
const Profilepage = () => {
    // const [activeCategory, setActiveCategory] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [parentId, setParentId] = useState(null);
    // const [activeCategory, setActiveCategory] = useState("Allitems");
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    // const [quantities, setQuantities] = useState({});
    const [quantities, setQuantities] = useState({}); // Track quantities of items
    const [showPopup, setShowPopup] = useState(false);
    const [popupItem, setPopupItem] = useState(null);
    const [items, setItems] = useState([]); // Store API data
    // const [quantities, setQuantities] = useState({}); // Manage quantity state
    const [categories, setCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [dishes, setDishes] = useState([]);  // Added state for dishes
    const location = useLocation();
    const [posts, setPosts] = useState([]);
    const [activeCategory, setActiveCategory] = useState("Profile");
    const navigate = useNavigate(); // ✅ Define navigate before using it
    const [coupons, setCoupons] = useState([]);
    const userType = localStorage.getItem("userType"); // e.g., "PERSONAL" or "PROFESSIONAL"

    const storedCategory = localStorage.getItem("activeCategory");
    const isAdmin = localStorage.getItem("isAdmin") === "false";
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isMenuOpen, setIsMenuOpen] = useState(false); // New state for hamburger menu

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    useEffect(() => {
        if (storedCategory) {
            setActiveCategory(storedCategory);
            localStorage.removeItem("activeCategory"); // Clear after use
        }
    }, []);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Detect mobile screen (width ≤ 768px)
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Check initially

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        if (location.state?.activeCategory === 'Payments') {
            setActiveCategory('Payments');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Profile') {
            setActiveCategory('Profile');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Notifications') {
            setActiveCategory('Notifications');
        }
    }, [location]);
    // Function to handle card click and set the active category
    const handleClick = (category) => {
        setActiveCategory(category);
        if (isMobile) {
            setIsMenuOpen(false); // Close menu when item is selected
        }
    };

    const orderPosts = [
        { dishId: 1, orderId: "12345", orderType: "Dine-In" },
        { dishId: 2, orderId: "12346", orderType: "Take Away" },
        { dishId: 3, orderId: "12347", orderType: "Delivery" },
        { dishId: 1, orderId: "12345", orderType: "Dine-In" },
        { dishId: 2, orderId: "12346", orderType: "Take Away" },
        { dishId: 3, orderId: "12347", orderType: "Delivery" },
        { dishId: 1, orderId: "12345", orderType: "Dine-In" },
        { dishId: 2, orderId: "12346", orderType: "Take Away" },
        { dishId: 3, orderId: "12347", orderType: "Delivery" },
    ];

    const iconMap = {
        Profile: <FaUser />,
        "Delivery Partner": <FaBiking />,
        Cart: <FaShoppingCart />,
        Wallet: <FaCreditCard />,
        "Add employee": <FaCreditCard />,
        Payments: <FaMoneyCheckAlt />,
        Orders: <FaList />,
        Favorites: <FaHeart />,
        // Subscription: <FaMapMarkerAlt />,
        Notifications: <FaBell />,
        "Support team": <FaHeadset />,
        Settings: <FaCog />,
    };
    // Automatically activate the first item from backend data
    useEffect(() => {
        if (categories.length > 0) {
            setActiveCategory("Allitems"); // Default to "Allitems"
        }
    }, [categories]);

    const currentCategoryItems = categories[activeCategory] || [];

    const filteredItems = currentCategoryItems.filter((item) => {
        if (isVegSelected) return item.type === "Veg";
        if (isNonVegSelected) return item.type === "Non-veg";
        return true;
    });
    const scrollContainerRef = useRef(null);
    useEffect(() => {
        axios.get('https://backend.maamaas.com/food/dish/getall')
            .then((response) => {
                const allDishes = response.data;

                // Filter for dishes with the name "Combos"
                const combos = allDishes.filter(dish => dish.dishName === "Combos");

                // Find child dishes with matching parentId
                const filteredData = allDishes.filter(dish =>
                    combos.some(combo => combo.dishId === dish.parentId)
                );

                setPosts(filteredData);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1; // Scroll down smoothly

                    // Infinite loop logic
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0; // Reset to top for seamless loop
                    }
                }
            }, 20); // Adjust speed by changing interval
        };

        startScrolling();

        return () => clearInterval(interval);
    }, [isHovered]);

    const dishImages = {
        1: { image: menu1 },
        2: { image: menu1 },
        3: { image: menu1 },
    };
    useEffect(() => {
        // Fetch coupons from API
        axios
            .get(
                "https://backend.maamaas.com/food/coupon/vendor/3/active"
            )
            .then((res) => {
                if (res.data) {
                    setCoupons(res.data); // assuming API returns array of coupons
                }
            })
            .catch((err) => {
                console.error("Error fetching coupons:", err);
            });
    }, []);

    // ✅ Dummy Coupons (अगर API नहीं है तो ये चलेंगे)
    useEffect(() => {
        setCoupons([
            { code: "PIZZA50", discountPercentage: 50, dishId: 1 },
            { code: "BURGER30", discountPercentage: 30, dishId: 2 },
            { code: "DEL99", discountPercentage: 20, dishId: 3 },
        ]);
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMenuOpen && !event.target.closest('.mobile-menu-container') && !event.target.closest('.hamburger-icon')) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isMenuOpen]);


    return (
        <>
            <div>
                <div className="container-fluid" style={{ marginTop: "40px" }}>
                    <div className="row">
                        {/* Left Column - Scrollable Category List */}
                        <div className="col-lg-2 col-md-3 col-sm-12 col-12">
                            {(() => {
                                const categories = [
                                    "Profile",
                                    "Wallet",
                                    ...(userType === "PROFESSIONAL" ? ["Add employee"] : []),
                                    "Orders",
                                    "Favorites",
                                    "Notifications",
                                    "Support team",
                                    "Settings"
                                ];

                                return isMobile ? (
                                    <>
                                        {/* Hamburger Menu Button */}
                                        <div className="mobile-menu-container mb-3">
                                            <button
                                                className="hamburger-btn"
                                                onClick={() => setIsMenuOpen(!isMenuOpen)}
                                                style={{
                                                    width: "50px",
                                                    padding: "12px",
                                                    borderRadius: "8px",
                                                    border: "none",
                                                    backgroundColor: "#f7f3f3ff",
                                                    color: "rgb(177 93 198)",
                                                    fontWeight: 'bold',
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    marginBottom: "10px",
                                                    position: "relative",
                                                    top: "20px",
                                                }}
                                            >
                                                {isMenuOpen ? <FaTimes /> : <FaBars />}
                                            </button>

                                            {/* Slide-out Menu Overlay */}
                                            <div
                                                className={`mobile-menu-overlay ${isMenuOpen ? 'active' : ''}`}
                                                style={{
                                                    position: "fixed",
                                                    top: "54px",
                                                    left: 0,
                                                    width: "70%",
                                                    height: "100%",
                                                    backgroundColor: "#fff",
                                                    boxShadow: "2px 0 10px rgba(0,0,0,0.2)",
                                                    zIndex: 1000,
                                                    transform: isMenuOpen ? "translateX(0)" : "translateX(-100%)",
                                                    transition: "transform 0.2s ease-in-out",
                                                    paddingTop: "0px",
                                                    overflowY: "auto"
                                                }}
                                            >
                                                {/* Menu Items */}
                                                <div className="mobile-menu-items">
                                                    {categories.map((category, index) => (
                                                        <div
                                                            key={index}
                                                            className="mobile-menu-item"
                                                            onClick={() => handleClick(category)}
                                                            style={{
                                                                padding: "10px 20px",
                                                                borderBottom: "1px solid #f5f5f5",
                                                                cursor: "pointer",
                                                                backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "transparent",
                                                                color: activeCategory === category ? "#fff" : "#333",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "15px",
                                                                transition: "all 0.1s ease",
                                                                fontWeight: "400"
                                                            }}
                                                        >
                                                            <span style={{ fontSize: "18px", width: "20px" }}>
                                                                {iconMap[category]}
                                                            </span>
                                                            <span style={{ fontSize: "14px" }}>{category}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Backdrop Overlay */}
                                            {/* {isMenuOpen && (
                                                <div
                                                    className="menu-backdrop"
                                                    onClick={() => setIsMenuOpen(false)}
                                                    style={{
                                                        position: "fixed",
                                                        top: 0,
                                                        left: 0,
                                                        width: "200px",
                                                        height: "100vh",
                                                        backgroundColor: "rgba(0,0,0,0.5)",
                                                        zIndex: 999,
                                                    }}
                                                />
                                            )} */}
                                        </div>
                                    </>
                                ) : (

                                    // Desktop view (your existing code)
                                    <div
                                        style={{
                                            // maxHeight: "1500px",
                                            position: "sticky",
                                            top: "0px",
                                            marginTop: "15px",
                                            // height: '950px',
                                            overflow: 'auto',
                                            width: "180px",
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                        }}
                                        className="scrool-sticky-data"
                                    >
                                        <div
                                            className="category-container"
                                            style={{
                                                overflowY: "auto",
                                                height: "670px",
                                                maxHeight: "calc(100vh - 100px)",
                                                marginTop: "78px",
                                                scrollbarWidth: "none",
                                                msOverflowStyle: "none",
                                            }}
                                        >
                                            {categories.map((category, index) => (
                                                <div
                                                    key={index}
                                                    className="category-card"
                                                    onClick={() => handleClick(category)}
                                                    style={{
                                                        backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                        margin: "16px 0",
                                                        padding: "10px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexDirection: "column",
                                                        cursor: "pointer",
                                                        justifyContent: "center",
                                                        borderRadius: "15px",
                                                        transition: "0.3s ease-in-out",
                                                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                    }}
                                                >
                                                    <div className="icon-wrapper">
                                                        {iconMap[category]}
                                                    </div>
                                                    <div className="category-card-body d-flex justify-content-center p-0">
                                                        <button className="category-button" style={{ width: "140px", color: "#000", backgroundColor: "#fff" }} >{category}</button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>

                        {/* Right Column - Content Based on Active Category */}
                        <div className="col-lg-7 col-md-6 col-sm-12 col-12">
                            <div
                                className="profilemargin"
                                style={{
                                    marginTop: isMobile ? "20px" : "65px", // Adjusted for mobile
                                    borderRadius: "8px",
                                }}
                            >
                                {/* Breadcrumb - This will now be at the top in mobile */}
                                <p
                                    className="breadcrumb"
                                    style={{
                                        marginTop: isMobile ? "0px" : "-32px",
                                        fontSize: isMobile ? "18px" : "22px",
                                        marginLeft: "15px",
                                        marginBottom: "20px",
                                        paddingTop: isMobile ? "10px" : "0"
                                    }}
                                >
                                    <Link
                                        to="/homepage"
                                        style={{
                                            color: "#b15cd6",
                                            fontWeight: 'bold',
                                            textDecoration: "none",
                                            fontSize: isMobile ? "16px" : "inherit"
                                        }}
                                    >
                                        Home
                                    </Link>
                                    <span className="separator"> &gt; </span>
                                    <span style={{ color: "#b15cd6", fontWeight: 'bold' }}>
                                        {activeCategory}
                                    </span>
                                </p>

                                {/* Your existing content sections */}
                                {activeCategory === "Profile" && <Profile />}
                                {activeCategory === "Wallet" && <Payment />}
                                {activeCategory === "Add employee" && userType === "PROFESSIONAL" && <AddWalletEmployee />}
                                {activeCategory === "Orders" && <Order />}
                                {activeCategory === "Favorites" && <Favorites />}
                                {activeCategory === "Notifications" && <Notifications />}
                                {activeCategory === "Support team" && <Support />}
                                {activeCategory === "Settings" && <Settings />}
                            </div>
                        </div>

                        {/* Right Sidebar - Hidden on mobile */}
                        <div
                            className="col-lg-3"
                            style={{ display: isMobile ? "none" : "block" }}
                        >
                            <SidescrollAdvertisements />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );


};

export default Profilepage;
